import React, { useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Select } from "antd";
import Globeicon from "../../assets/images/globeicon.png";

import { useSelector } from "react-redux";
import { getQuizTime } from "../../utils/helpers";
import { RootState } from "../../store";

import intro from "../../assets/audio/Intro.mp3";

const { Option } = Select;

const QuizPage2 = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { questions, time_limit } = useSelector((state: RootState) => state.quiz);
  const introSound = useRef(new Audio(intro)).current;

  // This is Used For Close Right Click
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Logic for key down if needed, but preventDefault might be too aggressive
      // event.preventDefault(); 
    };

    const handleContextMenu = (event: MouseEvent) => {
      event.preventDefault();
    };

    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("contextmenu", handleContextMenu);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, []);

  const handleContinue = () => {
    introSound.play();
    navigate(`/quiz/${id}/1`, { replace: true });
  };

  const totalQuestions = Object.keys(questions).length;

  return (
    <>
      <div className="quiz-main-container">
        <div className="quiz-select-container">
          <Select
            className="quiz-select"
            defaultValue="English"
            suffixIcon={
              <img
                src={Globeicon}
                alt="Globe Icon"
                className="quiz-select-icon"
              />
            }
          >
            <Option value="English">English</Option>
            <Option value="Spanish">Spanish</Option>
            <Option value="French">French</Option>
          </Select>
        </div>

        <div className="instruction-container">
          <div className="instruction-box">
            <InstructionContent
              index={1}
              content={`Total of <span style="color: #004883;">${totalQuestions} questions</span> `}
            />
            <InstructionContent
              index={2}
              content={`Time limit will be <span style="color: #004883;">${getQuizTime(time_limit).split(' ')[0]} minutes</span> `}
            />
            <InstructionContent
              index={3}
              content={`Only <span style="color: #004883;">1 correct</span> option`}
            />
            <InstructionContent
              index={4}
              content={`Participants can <span style="color: #004883;">quit anytime</span>`}
            />
            <div className="instruction-heading">Instructions</div>
          </div>
        </div>
        <div className="continue-container">
          <button onClick={handleContinue} className="continue-box">
            Start Quiz
          </button>
        </div>
      </div>
    </>
  );
};

export default QuizPage2;

interface InstructionContentProps {
  index: number;
  content: string;
}

const InstructionContent: React.FC<InstructionContentProps> = ({ content }) => (
  <div className="instruction-content">
    <div className="instruction-dot"></div>
    <p className="instruction-text" dangerouslySetInnerHTML={{ __html: content }}></p>
  </div>
);
